import { useEffect, useState } from 'react'
import { useAuthStore } from '../store/auth'

interface Props {
  entryId: string
  size?: number
}

export function AvatarImage({ entryId, size = 64 }: Props) {
  const [blobUrl, setBlobUrl] = useState<string | null>(null)
  const token = useAuthStore((s) => s.token)

  useEffect(() => {
    let url: string | null = null
    fetch(`/api/v1/entries/${encodeURIComponent(entryId)}/download`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    })
      .then((r) => (r.ok ? r.blob() : Promise.reject()))
      .then((blob) => { url = URL.createObjectURL(blob); setBlobUrl(url) })
      .catch(() => {})
    return () => { if (url) URL.revokeObjectURL(url) }
  }, [entryId, token])

  if (!blobUrl) {
    return (
      <div style={{
        width: size, height: size, borderRadius: '50%',
        background: 'var(--color-fg)', opacity: 0.15, flexShrink: 0,
      }} />
    )
  }

  return (
    <img
      src={blobUrl}
      alt="avatar"
      style={{ width: size, height: size, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
    />
  )
}
